import React from 'react';
import { Welcome1 } from '../components/Data/Arabic';
import { Welcome2 } from '../components/Data/English';

const Message = ({lang}) => {

  const Data = lang ? Welcome2 : Welcome1;

  return (
    <div className='basis-80 py-24 bg-lightgray sm:w-full'>
        {
          Data.map(item => (
             <div key={item.id} className={lang ? "text-center box-decoration-clone" : "text-center"}>
                <h1 className='text-6xl mb-11 lg:mb-16 font-black md:text-5xl sm:text-2xl' >{item.title}</h1>
                <p className='text-3xl lg:text-3xl font-black mb-10 lg:mb-10 sm:mb-5 md:text-2xl sm:text-xs'>{item.line}</p>
                <q className='text-3xl lg:text-3xl font-black md:text-2xl sm:text-xs '>{item.quote}</q>
            </div> 
          ))
        } 
    </div>
  )
}

export default Message;

